"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiveTypography = void 0;
var responsiveTypographyH1 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h1), (_a = { fontSize: typography.pxToRem(30), lineHeight: 1.13, letterSpacing: typography.pxToEm(-0.5, 30) }, _a[breakpoints.up("lg")] = {
        fontSize: typography.pxToRem(40),
        lineHeight: typography.pxToEm(-0.5, 40),
    }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(50),
        lineHeight: 1.08,
        letterSpacing: typography.pxToEm(-1, 50),
    }, _a)));
};
var responsiveTypographyH2 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h2), (_a = { fontSize: typography.pxToRem(26), lineHeight: 1.15, letterSpacing: typography.pxToEm(-0.3, 26) }, _a[breakpoints.up("lg")] = {
        fontSize: typography.pxToRem(30),
        lineHeight: 1.13,
        letterSpacing: typography.pxToEm(-0.5, 30),
    }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(36),
        lineHeight: 1.11,
        letterSpacing: typography.pxToEm(-0.7, 36),
    }, _a)));
};
var responsiveTypographyH3 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h3), (_a = { fontSize: typography.pxToRem(18), lineHeight: 1.44, letterSpacing: typography.pxToEm(-0.2, 18) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(22),
        lineHeight: 1.27,
        letterSpacing: typography.pxToEm(-0.4, 22),
    }, _a)));
};
var responsiveTypographyH4 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h4), (_a = { fontSize: typography.pxToRem(18), lineHeight: 1.44, letterSpacing: typography.pxToEm(-0.2, 18) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(22),
        lineHeight: 1.27,
        letterSpacing: typography.pxToEm(-0.4, 22),
    }, _a)));
};
var responsiveTypographyBody1 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.body1), (_a = { fontSize: typography.pxToRem(14), lineHeight: 1.43, letterSpacing: typography.pxToEm(0.2, 14) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(16),
        lineHeight: 1.5,
        letterSpacing: "normal",
    }, _a)));
};
var responsiveTypographyCaption = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.caption), (_a = { fontSize: typography.pxToRem(12), lineHeight: 1.5, letterSpacing: "normal" }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(14),
        lineHeight: 1.43,
    }, _a)));
};
var responsiveTypographyButton = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.button), (_a = { fontSize: typography.pxToRem(12), lineHeight: 1.33, letterSpacing: typography.pxToEm(0.5, 12) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(14),
        lineHeight: 1.14,
        letterSpacing: typography.pxToEm(1, 14),
    }, _a)));
};
var responsiveTypographyOverline = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.overline), (_a = { fontSize: typography.pxToRem(9), letterSpacing: typography.pxToEm(1, 9) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(11),
        lineHeight: 1.33,
        letterSpacing: typography.pxToEm(0.5, 11),
    }, _a)));
};
var responsiveTypography = function (theme) {
    var typography = theme.typography, breakpoints = theme.breakpoints;
    var h1 = responsiveTypographyH1(typography, breakpoints);
    var h2 = responsiveTypographyH2(typography, breakpoints);
    var h3 = responsiveTypographyH3(typography, breakpoints);
    var h4 = responsiveTypographyH4(typography, breakpoints);
    var body1 = responsiveTypographyBody1(typography, breakpoints);
    var caption = responsiveTypographyCaption(typography, breakpoints);
    var button = responsiveTypographyButton(typography, breakpoints);
    var overline = responsiveTypographyOverline(typography, breakpoints);
    return __assign(__assign({}, theme), { typography: __assign(__assign({}, theme.typography), { h1: h1, h2: h2, h3: h3, h4: h4, body1: body1, body2: body1, caption: caption, button: button, overline: overline }) });
};
exports.responsiveTypography = responsiveTypography;
//# sourceMappingURL=responsiveTypography.js.map